import './tastece/style';
import FormStructure from './tastece/form_structure';

export default FormStructure;